<template>
  <div class="swiper">
    <div class="mobile" v-if="isMobile == 1">
      <el-carousel trigger="click" height="310px">
        <el-carousel-item v-for="(item, index) in carousel" :key="index">
          <img style="width: 100%" :src="require('@/assets/'+item)" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="pc" v-if="isMobile == 0">
      <el-carousel trigger="click" height="530px">
        <el-carousel-item v-for="(item, index) in carousel" :key="index">
          <img style="width: 100%" :src="require('@/assets/'+item)" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "swiper",
  props: {
    msg: String,
  },
  data() {
    return {
      isMobile: false,
      carousel: [
        "banner.png",
        "banner2.png",
        "banner3.png",
        "banner4.png",
        "banner5.png",
      ],
    };
  },
  // created() {
  //   // this.$nextTick(()=>{
  //     // this.isMobile = localStorage.getItem("isMobile")
  //   // })
  // },
  mounted() {
    console.log(this.carousel[0]);
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style scoped lang="less"></style>
<style scoped lang='less'>
.pc {
  /deep/ .el-carousel__indicator--horizontal {
    padding: 60px 10px;

    .el-carousel__button {
      width: 30px;
      height: 10px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
    }
  }
}

.mobile {
  /deep/ .el-carousel__indicator--horizontal {
    padding: 20px 10px;

    .el-carousel__button {
      width: 30px;
      height: 10px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
    }
  }
}

/deep/ .el-carousel__indicator--horizontal.is-active {
  .el-carousel__button {
    width: 60px;
  }
}
</style>

